
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/officials/registrations_view.css.ts.vanilla.css\",\"source\":\"Ll8xZW5iMzNtMCB7CiAgd2lkdGg6IDEwNXB4Owp9Ci5fMWVuYjMzbTEgewogIHdpZHRoOiAyNTBweDsKfQouXzFlbmIzM20yIHsKICB3aWR0aDogMjAwcHg7Cn0KLl8xZW5iMzNtMyB7CiAgd2lkdGg6IDEwMHB4Owp9Ci5fMWVuYjMzbTQgewogIGNvbG9yOiB2YXIoLS1fMWo3cnA1NzkpOwp9Ci5fMWVuYjMzbTQ6dmlzaXRlZCB7CiAgY29sb3I6IHZhcigtLV8xajdycDU3OSk7Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/public-app/officials/registrations_view.css.ts.vanilla.css\",\"source\":\"Ll8xZW5iMzNtMCB7CiAgd2lkdGg6IDEwNXB4Owp9Ci5fMWVuYjMzbTEgewogIHdpZHRoOiAyNTBweDsKfQouXzFlbmIzM20yIHsKICB3aWR0aDogMjAwcHg7Cn0KLl8xZW5iMzNtMyB7CiAgd2lkdGg6IDEwMHB4Owp9Ci5fMWVuYjMzbTQgewogIGNvbG9yOiB2YXIoLS1fMWo3cnA1NzkpOwp9Ci5fMWVuYjMzbTQ6dmlzaXRlZCB7CiAgY29sb3I6IHZhcigtLV8xajdycDU3OSk7Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
